import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import AboutPage from "@/pages/about/page";
import BrandsPage from "@/pages/brands/page";
import ServicesPage from "@/pages/services/page";
import MarketsPage from "@/pages/markets/page";
import ContactPage from "@/pages/contact/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import NewsAdminPage from "@/pages/admin/news/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/about", element: <AboutPage /> },
      { path: "/brands", element: <BrandsPage /> },
      { path: "/services", element: <ServicesPage /> },
      { path: "/markets", element: <MarketsPage /> },
      { path: "/contact", element: <ContactPage /> },
      { path: "/news", element: <NewsPage /> },
      { path: "/news/:slug", element: <NewsDetailPage /> },
      { path: "/admin/news", element: <NewsAdminPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;